import type { ToolbarComponentTypes } from '@atlaskit/editor-toolbar-model/types';

import { INPUT_METHOD } from '../analytics';
import { TOOLBARS } from './keys';

export const getInputMethodFromParentKeys = (
	parents: ToolbarComponentTypes,
): INPUT_METHOD.FLOATING_TB | INPUT_METHOD.TOOLBAR =>
	parents.at(0)?.key === TOOLBARS.INLINE_TEXT_TOOLBAR
		? INPUT_METHOD.FLOATING_TB
		: INPUT_METHOD.TOOLBAR;
